import React, { useEffect, useState } from "react";
import { Slider } from "@mui/material";
import {
  RADIUS_SLIDER_INFINITY,
  RADIUS_SLIDER_MARKS,
  radiusForSlider,
  radiusFromSlider,
} from "../services/radius";

export default function CommittedRadiusSlider({ value, onChange }) {
  const committedValue = radiusForSlider(value);
  const [draftValue, setDraftValue] = useState(committedValue);

  useEffect(() => {
    setDraftValue(committedValue);
  }, [committedValue]);

  const commitValue = (_event, nextValue) => {
    if (nextValue !== committedValue) {
      onChange(radiusFromSlider(nextValue));
    }
  };

  return (
    <Slider
      value={draftValue}
      onChange={(_event, nextValue) => setDraftValue(nextValue)}
      onChangeCommitted={commitValue}
      step={1}
      min={2}
      max={RADIUS_SLIDER_INFINITY}
      marks={RADIUS_SLIDER_MARKS}
      sx={{
        width: "calc(100% - 8px)",
        "& .MuiSlider-markLabel": { whiteSpace: "nowrap" },
        "& .MuiSlider-markLabel[data-index='4']": {
          transform: "translateX(calc(-100% - 4px))",
        },
        "& .MuiSlider-markLabel[data-index='5']": {
          transform: "translateX(4px)",
        },
      }}
    />
  );
}
